import { FunctionComponent, useEffect } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { II18n } from '../../../../models';
import { I18nService } from '../../../../services';
import style from './AccessDenied.module.scss';

interface AccessDeniedProps {
  redirectToHome?: boolean;
}

const AccessDenied: FunctionComponent<AccessDeniedProps> = (
  props: AccessDeniedProps,
) => {
  var navigate: NavigateFunction | null = null;

  try {
    navigate = useNavigate();
  } catch (error) {
    console.error("useNavigate só pode ser usado dentro de um contexto de <Router>.", error);
    navigate = null;
  }

  useEffect(() => {
    if (props.redirectToHome) {
      setTimeout(() => {
        if(navigate)
        navigate('/home');
      }, 3000);
    }
  }, [props.redirectToHome, navigate]);

  return (
    <div className={style['main-document']}>
      <h4>{translate('accessDenied')}</h4>
      <img
        src='/images/access_denied.svg'
        title={translate('accessDenied')}
        alt={translate('accessDenied')}
        className={style.img}
      />
    </div>
  );
};

AccessDenied.defaultProps = {
  redirectToHome: true,
};

const translations: II18n = {
  es: {
    accessDenied: 'Se le ha denegado el acceso',
  },
  enUS: {
    accessDenied: 'Your access has been denied',
  },
  ptBR: {
    accessDenied: 'Seu acesso foi negado',
  },
};

const translate = (key: string, args?: string[]): string =>
  new I18nService(translations).translate(key, args);

export { AccessDenied };
